import styled from 'styled-components';

export const SpeedToMarketPageWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const ContentDiv = styled.div`
	height: 100%;
	overflow: hidden;
`;
